import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import { ChartBar } from "@phosphor-icons/react";
import api from "@/lib/api";

const RANGES = [7, 14, 30];

export function PromotionStatsChart({ refreshKey }) {
  const [days, setDays] = useState(14);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/market/business/promotions/stats", { params: { days } })
      .then(({ data }) => setRows(data.map((r) => ({ ...r, label: r.date.slice(5) })))).catch(() => setRows([]));
  }, [days, refreshKey]);
  const totals = rows.reduce((a, r) => ({ views: a.views + r.views, taps: a.taps + r.taps }), { views: 0, taps: 0 });

  return (
    <div className="space-y-3" data-testid="promotion-stats-chart">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-bold text-sky-800 uppercase tracking-wider flex items-center gap-1"><ChartBar size={14} weight="fill" /> Daily views &amp; taps</p>
        <div className="flex gap-1">
          {RANGES.map((d) => (
            <button key={d} data-testid={`promotion-stats-range-${d}`} onClick={() => setDays(d)}
              className={`h-7 px-2.5 rounded-full text-xs font-bold transition-colors ${days === d ? "bg-sky-950 text-white" : "bg-sky-50 text-sky-800 hover:bg-sky-100"}`}>{d}d</button>
          ))}
        </div>
      </div>
      <p className="text-sm text-sky-900" data-testid="promotion-stats-totals">
        <b>{totals.views}</b> saw it · <b>{totals.taps}</b> tapped in the last {days} days
      </p>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} margin={{ top: 4, right: 4, left: -24, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e0f2fe" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#0369a1" }} interval="preserveStartEnd" />
            <YAxis allowDecimals={false} tick={{ fontSize: 10, fill: "#0369a1" }} />
            <Tooltip cursor={{ fill: "#f0f9ff" }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="views" name="Saw it" fill="#38bdf8" radius={[4, 4, 0, 0]} />
            <Bar dataKey="taps" name="Tapped" fill="#0c4a6e" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
